import React from 'react';
import './Title.css'

const Title = (props) => {
    return (
      <>
        {props.text1 && <div className={props.css2}>{props.text1}</div>}
        {props.text2 && <div className={props.css6}>{props.text2}</div>}
        {props.text3 && <div className={props.css8}>{props.text3}</div>}
        {props.text4 && <div className={props.css0}>{props.text4}</div>}
        {props.text5 && <div className={props.css11}>{props.text5}</div>}
      </>
    );
  }
 
export default Title;